function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  updateMedia(html) {
    const mediaGallerySource = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
    const mediaGalleryDestination = html.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);

    const refreshSourceData = () => {
      const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
      const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
      const sourceMap = new Map(mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }]));
      return [mediaGallerySourceItems, sourceSet, sourceMap];
    };

    if (mediaGallerySource && mediaGalleryDestination) {
      let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
      const mediaGalleryDestinationItems = Array.from(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
      const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
      let shouldRefresh = false;

      // add items from new data not present in DOM
      for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
        if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
          mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
          shouldRefresh = true;
        }
      }

      // remove items from DOM not present in new data
      for (let i = 0; i < mediaGallerySourceItems.length; i++) {
        if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
          mediaGallerySourceItems[i].remove();
          shouldRefresh = true;
        }
      }

      // refresh
      if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

      // if media galleries don't match, sort to match new data order
      mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
        const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

        if (sourceData && sourceData.index !== destinationIndex) {
          mediaGallerySource.insertBefore(
            sourceData.item,
            mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
          );

          // refresh source now that it has been modified
          [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
        }
      });
    }

    if (this.currentVariant.featured_media) {
      document
        .querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
        ?.setActiveMedia?.(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
    }

    // update media modal
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newModalContent = html.querySelector(`product-modal`);
    if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        this.updateMedia(html);

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  
    connectedCallback() {
    const handleIntersection = (entries, observer) => {
      
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
          RentSettingsSwiper.init();
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}
customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();
    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);


// Lazy Loading
var rttLazyloadImg = {
  init: function() {
      this.lazyReady()
  },
  lazyReady: function() {
      if (window.IntersectionObserver) {
          let e = new IntersectionObserver(((e, t) => {
              e.forEach((e => {
                  e.isIntersecting && (e.target.width = e.boundingClientRect.width, e.target.height = e.boundingClientRect.height, e.target.sizes = `${e.boundingClientRect.width}px`, e.target.classList.add("rtt-loaded-image"), e.target.closest(".rtt-image-js").classList.remove("rtt-loading-image"), t.unobserve(e.target))
              }))
          }), {
              rootMargin: "10px"
          });
          document.querySelectorAll(".rtt-image-js img").forEach((t => {
              e.observe(t)
          }))
      }
  }
};
rttLazyloadImg.init();
document.addEventListener("shopify:section:load", function(event) {
  rttLazyloadImg.init();
});
// Collection product slider homepage


var RttSettingsProductSwiper = {
  init: function() {
      this.RttSettingsCarousel();
  },
  RttSettingsCarousel: function() {
      document.querySelectorAll(".rtt__swiper").forEach((e => {
          this.RttCarousel(e);
      }))
  },
  RttCarousel: function(e) {
      var t = "true" === e?.dataset.autoplay,
          n = "true" === e.dataset.loop,
          w = e?.dataset.rows ? e?.dataset.row : 1,
          o = e?.dataset.slideshow ? e?.dataset.slideshow : 0,
          pgm = e?.dataset.spgmobile ? e?.dataset.spgmobile : 1,
          pgt = e?.dataset.spgtablet ? e?.dataset.spgtablet : 1,
          pgd = e?.dataset.spgdesktop ? e?.dataset.spgdesktop : 1,
          i = e?.dataset.desktop ? e?.dataset.desktop : 4,
          s = e?.dataset.tablet ? e?.dataset.tablet : 2,
          r = e?.dataset.mobile ? e?.dataset.mobile : 1,
          a = e?.dataset.autoplaySpeed ? e?.dataset.autoplaySpeed : 3e3,
          c = e?.dataset.speed ? e?.dataset.speed : 400,
          l = e?.dataset.effect ? e?.dataset.effect : "slide",
          d = e?.dataset.sectionId,
          u = e?.dataset.row ? e?.dataset.row : 1,
          ut = e?.dataset.rowtablet ? e?.dataset.rowtablet : 1,
          um = e?.dataset.rowmobile ? e?.dataset.rowmobile : 1,
          p = window.innerWidth,
          m = e?.dataset.spacing ? e?.dataset.spacing : 0;
          cs = "true" === e.dataset.centerslide, 
          desktop = parseInt(pgd);
          tablet = parseInt(pgt);
          mobile = parseInt(pgm);
          al = e?.dataset.arrowleft ? e?.dataset.arrowleft : "swiper-button-prev",
          ar = e?.dataset.arrowright ? e?.dataset.arrowright : "swiper-button-next",
          m = Number(m), a = Number(a), c = Number(c), p <= 767 ? m >= 15 && (m = 15) : p <= 1199 && m >= 30 && (m = 30), new Swiper("#twa__swiper-" + d, {
          slidesPerView: r,
          slidesPerColumn: w,
          slidesPerGroup: mobile, 
          spaceBetween: m,
          centeredSlides: cs,
          autoplay: t,
          delay: a,
          loop: n,
          effect: l,
          speed: c,
          watchSlidesProgress: !0,
          watchSlidesVisibility: !0,
          draggable: true,
          grid: {
              rows: um,
              fill: "row"
          },
          navigation: {
            nextEl: `.${ar}`,
            prevEl: `.${al}`,
          },
          pagination: {
              clickable: !0,
              el: e.querySelector(".swiper-pagination")
          },
          breakpoints: {
              768: {
                  slidesPerView: s,
                  centeredSlides: cs,
                  slidesPerGroup: tablet,
                  grid: {
                    rows: ut,
                    fill: "row"
                  }
              },
              1450: {
                  slidesPerView: i,
                  slidesPerGroup: desktop,
                  grid: {
                    rows: u, 
                    fill: "row"
                  }
              }
          }
      })
  }
};
RttSettingsProductSwiper.init();
document.addEventListener("shopify:section:load", function(event) {
  RttSettingsProductSwiper.init();
});

// Global Slider setting

var RentSettingsSwiper = {
  init: function() {
      this.RentSettingsCarousel()
  },
  RentSettingsCarousel: function() {
      document.querySelectorAll(".rent__swiper").forEach((e => {
          this.RentCarousel(e)
      }))
  },
  RentCarousel: function(e) {
      var t, n = "true" === e?.dataset.autoplay,
          o = "true" === e?.dataset.loop,
          i = e?.dataset.slideshow ? e?.dataset.slideshow : 0,
          s = e?.dataset.arrowCenterimage ? e?.dataset.arrowCenterimage : 0,
          l = e?.dataset.desktop ? e?.dataset.desktop : 4,
          r = e?.dataset.tablet ? e?.dataset.tablet : 2,
          a = e?.dataset.mobile ? e?.dataset.mobile : 1,
          c = e?.dataset.autoplaySpeed ? e?.dataset.autoplaySpeed : 3e3,
          d = e?.dataset.speed ? e?.dataset.speed : 400,
          u = e?.dataset.effect ? e?.dataset.effect : "slide",
          m = e?.dataset.sectionId,
          p = e?.dataset.row ? e?.dataset.row : 1,
          h = e?.dataset.spacing ? e?.dataset.spacing : 0,
          g = "true" === e?.dataset.paginationProgressbar,
          f = "true" === e?.dataset.animationSrcoll,
          al = e?.dataset.arrowleft ? e?.dataset.arrowleft : "swiper-button-prev",
          ar = e?.dataset.arrowright ? e?.dataset.arrowright : "swiper-button-next",
          v = window.innerWidth,
          b = "true" === e?.dataset.itemMobile,
          cs = e.dataset.centerslide==="true",
          ct = e.dataset.css==="true",
          pg = e?.dataset.paginationtype ? e?.dataset.paginationtype : "slide";
         console.log(ct);
      h = Number(h), c = Number(c), d = Number(d), n && (n = {
          delay: c
      }), t = new Swiper("#rent__swiper-" + m, {
          slidesPerView: b ? "auto" : a, 
          spaceBetween: h >= 15 ? 15 : h,
          autoplay: n,
          loop: o,
          effect: u,
          speed: d,
          watchSlidesProgress: !0,
          watchSlidesVisibility: !0,
          cssMode: ct,
          grid: {
              rows: p,
              fill: "row"
          },
          navigation: {
              // nextEl: e.querySelector(".swiper-button-next"),
              // prevEl: e.querySelector(".swiper-button-prev")
            nextEl: `.${ar}`,
            prevEl: `.${al}`
          },
          pagination: {
              clickable: !0,
              el: e.querySelector(".swiper-pagination"),
              type: g ? "fraction" : "bullets"
          },
          breakpoints: {
              768: {
                  slidesPerView: r,
                  spaceBetween: h >= 30 ? 30 : h,
              },
              1200: {
                  slidesPerView: l,
                  spaceBetween: h,
                  centeredSlides: cs,
              }
          },
          on: {
              init: function() {
                  if (i && (v > 767 ? document.querySelectorAll(".slide-image").forEach((e => {
                          var t = e?.dataset.imgSlide;
                          e.innerHTML = `<img \n                      src=${t} \n                      alt="slide" \n                      srcset="${t}&amp;width=375 375w, ${t}&amp;width=550 550w, ${t}&amp;width=750 750w, ${t}&amp;width=1100 1100w, ${t}&amp;width=1500 1500w, ${t}&amp;width=1780 1780w, ${t}&amp;width=2000 2000w, ${t}&amp;width=3000 3000w, ${t}&amp;width=3840 3840w" \n                      sizes="100vw"\n                    >`
                      })) : document.querySelector(".slide-image-mobile") ? document.querySelectorAll(".slide-image-mobile").forEach((e => {
                          var t = e?.dataset.imgSlideMobile;
                          e.innerHTML = `<img \n                        src=${t} \n                        alt="slide mobile" \n                        srcset="${t}&amp;width=375 375w, ${t}&amp;width=550 550w, ${t}&amp;width=750 750w, ${t}&amp;width=1100 1100w, ${t}&amp;width=1500 1500w, ${t}&amp;width=1780 1780w, ${t}&amp;width=2000 2000w, ${t}&amp;width=3000 3000w, ${t}&amp;width=3840 3840w" \n                        sizes="100vw"\n                      >`
                      })) : document.querySelectorAll(".slide-image").forEach((e => {
                          var t = e?.dataset.imgSlide;
                          e.innerHTML = `<img \n                        src=${t} \n                        alt="slide" \n                        srcset="${t}&amp;width=375 375w, ${t}&amp;width=550 550w, ${t}&amp;width=750 750w, ${t}&amp;width=1100 1100w, ${t}&amp;width=1500 1500w, ${t}&amp;width=1780 1780w, ${t}&amp;width=2000 2000w, ${t}&amp;width=3000 3000w, ${t}&amp;width=3840 3840w" \n                        sizes="100vw"\n                      >`
                      })), window.addEventListener("resize", (function() {
                          window.innerWidth <= 767 ? document.querySelector(".slide-image-mobile") ? document.querySelectorAll(".slide-image-mobile").forEach((e => {
                              var t = e?.dataset.imgSlideMobile;
                              e.innerHTML = `<img \n                          src=${t} \n                          alt="slide mobile" \n                          srcset="${t}&amp;width=375 375w, ${t}&amp;width=550 550w, ${t}&amp;width=750 750w, ${t}&amp;width=1100 1100w, ${t}&amp;width=1500 1500w, ${t}&amp;width=1780 1780w, ${t}&amp;width=2000 2000w, ${t}&amp;width=3000 3000w, ${t}&amp;width=3840 3840w" \n                          sizes="100vw"\n                        >`
                          })) : document.querySelectorAll(".slide-image").forEach((e => {
                              var t = e?.dataset.imgSlide;
                              e.innerHTML = `<img \n                          src=${t} \n                          alt="slide" \n                          srcset="${t}&amp;width=375 375w, ${t}&amp;width=550 550w, ${t}&amp;width=750 750w, ${t}&amp;width=1100 1100w, ${t}&amp;width=1500 1500w, ${t}&amp;width=1780 1780w, ${t}&amp;width=2000 2000w, ${t}&amp;width=3000 3000w, ${t}&amp;width=3840 3840w" \n                          sizes="100vw"\n                        >`
                          })) : document.querySelectorAll(".slide-image").forEach((e => {
                              var t = e?.dataset.imgSlide;
                              e.innerHTML = `<img \n                        src=${t} \n                        alt="slide" \n                        srcset="${t}&amp;width=375 375w, ${t}&amp;width=550 550w, ${t}&amp;width=750 750w, ${t}&amp;width=1100 1100w, ${t}&amp;width=1500 1500w, ${t}&amp;width=1780 1780w, ${t}&amp;width=2000 2000w, ${t}&amp;width=3000 3000w, ${t}&amp;width=3840 3840w" \n                        sizes="100vw"\n                      >`
                          }))
                      })), f && initializeScrollZoomAnimationTrigger()), s) {
                      var e = document.getElementById("rent__swiper-" + m),
                          t = e.querySelectorAll(".rtt__responsive-image");
                      if (0 != t.length) {
                          var n = [];
                          t.forEach((e => {
                              n.push(e.offsetHeight / 2)
                          }));
                          var o = "--arrows-offset-top: " + Math.max(...n) + "px";
                          e.querySelectorAll(".swiper-arrow") && e.querySelectorAll(".swiper-arrow").forEach((e => {
                              e.setAttribute("style", o)
                          }))
                      }
                  }
              }
          }
      }), i && t.on("slideChange", (function() {
          document.querySelectorAll(".video-slider").forEach((e => {
              var t = e.dataset.video,
                  n = e.dataset.poster;
              e.innerHTML = `\n              <video playsinline="true" loop="loop" muted="muted" autoplay="autoplay" preload="metadata"\n                poster="${n}">\n                <source\n                  src="${t}"\n                  type="video/mp4">\n              </video>\n              `
          }))
      }))
  }
};
RentSettingsSwiper.init();
document.addEventListener("shopify:section:load", function(event) {
  RentSettingsSwiper.init();
});


const slideAnime = (() => {
  let e = !1;
  return t => {
      const n = Object.assign({}, {
              target: !1,
              animeType: "slideToggle",
              duration: 400,
              easing: "ease",
              isDisplayStyle: "block"
          }, t),
          o = n.target;
      if (!o) return;
      if (e) return;
      e = !0;
      let i = n.animeType;
      const s = getComputedStyle(o);
      if ("slideToggle" === i && (i = "none" === s.display ? "slideDown" : "slideUp"), "slideUp" === i && "none" === s.display || "slideDown" === i && "none" !== s.display || "slideUp" !== i && "slideDown" !== i) return e = !1, !1;
      o.style.overflow = "hidden";
      const l = n.duration,
          r = n.easing,
          a = n.isDisplayStyle;
      "slideDown" === i && (o.style.display = a);
      const c = {
          height: o.getBoundingClientRect().height + "px",
          marginTop: s.marginTop,
          marginBottom: s.marginBottom,
          paddingTop: s.paddingTop,
          paddingBottom: s.paddingBottom
      };
      if (Object.keys(c).forEach((e => {
              0 === parseFloat(c[e]) && delete c[e]
          })), 0 === Object.keys(c).length) return e = !1, !1;
      let d;
      "slideDown" === i ? (Object.keys(c).forEach((e => {
          o.style[e] = 0
      })), d = o.animate(c, {
          duration: l,
          easing: r
      })) : "slideUp" === i && (Object.keys(c).forEach((e => {
          o.style[e] = c[e], c[e] = 0
      })), d = o.animate(c, {
          duration: l,
          easing: r
      })), d.finished.then((() => {
          o.style.overflow = "", Object.keys(c).forEach((e => {
              o.style[e] = ""
          })), "slideUp" === i && (o.style.display = "none"), e = !1
      }))
  }
})(); 
var RttToggle = {
  init: function () {
    this.initToggle();
  },
  initToggle: function () {
    document.querySelectorAll(".rtt__page-faq-title").forEach((title) => {
      title.addEventListener("click", (event) => {
        event.preventDefault();

        // Close all other accordions
        document.querySelectorAll(".rtt__page-faq-content").forEach((content) => {
          if (content !== title.nextElementSibling) {
            slideAnime({
              target: content,
              animeType: "slideUp",
            });
            content.parentElement.classList.remove("active");
          }
        });

        // Toggle the clicked accordion
        const content = title.nextElementSibling;
        if (content.parentElement.classList.contains("active")) {
          slideAnime({
            target: content,
            animeType: "slideUp",
          });
          content.parentElement.classList.remove("active");
        } else {
          slideAnime({
            target: content,
            animeType: "slideDown",
          });
          content.parentElement.classList.add("active");
        }
      });
    });
  },
};


RttToggle.init();


 document.addEventListener("DOMContentLoaded", (event) => {
  gsap.registerPlugin(ScrollTrigger);
 gsap.utils.toArray('.list-rotator-wrapper').forEach((listRotatorWrapper) => {
  						
    const listRotatorTitle = listRotatorWrapper.querySelector(".list-rotator-header");
    const listRotatorHeight = listRotatorWrapper.querySelector(".list-rotator-height");
    const listRotatorPin = listRotatorWrapper.querySelector(".list-rotator-pin");
    const listRotator = listRotatorWrapper.querySelector(".list-rotator");			
    const listItems = listRotatorWrapper.querySelectorAll('li');
    const totalItems = listItems.length - 1;
    const angleIncrement = 180 / totalItems;
    
    
      listItems.forEach(function(item, index) {
        const rotationAngle = index * angleIncrement;
        const fontSize = gsap.getProperty(item, "fontSize");
        const lineHeight = gsap.getProperty(item, "lineHeight");
        const translateZ = (parseFloat(fontSize) + parseFloat(lineHeight)) * 2.5;
        
        gsap.set(item, {
          rotationX: -rotationAngle,
          transformOrigin: `center center 0`,
          transform: `rotateX(${-rotationAngle}deg) translateZ(${translateZ}px)`,
          zIndex: totalItems - index, 
        });
      });			
      
      function setlistRotatorProperties() {		
        gsap.set(listRotatorWrapper, { height: window.innerHeight*3});
        gsap.set(listRotatorHeight, { height: window.innerHeight*4});
        gsap.set(listRotator, { height: window.innerHeight});
        ScrollTrigger.refresh();
      }
      
      gsap.set(listRotator, { rotationX:-90});
      
      setlistRotatorProperties();
      
      window.addEventListener('resize', setlistRotatorProperties);			 
      
      gsap.to(listRotatorTitle, {
        scrollTrigger: {
          trigger: listRotatorTitle,
          start: function() {
            const startPin = 20;
            return "top +=" + startPin;
          },
          end: function() {
            const endPin = window.innerHeight * 2;
            return "+=" + endPin; 
          },
          pin:true,
          scrub: true,
          pinSpacing: false,
        }
      });
      
      gsap.to(listRotatorPin, {
        scrollTrigger: {
          trigger: listRotatorPin,
          start: function() {
            const startPin = 0;
            return "top +=" + startPin;
          },
          end: function() {
            const endPin = window.innerHeight * 3.4;
            return "+=" + endPin;
          },
          pin:true,
          scrub: true,
          pinSpacing: false,
        }
      });
      
      gsap.to(listRotator, {
        scrollTrigger: {
          trigger: listRotatorWrapper,
          start: function() {
            const startPin = (window.innerHeight) * 0.8;
            return "top +=" + startPin;
          },
          end: function() {
            const endPin = window.innerHeight * 5.5;
            return "+=" + endPin;
          },
          scrub: true,
        },
        rotationX:250
      });
  }); 
});


var swiper = new Swiper(".my-carousel__swiper", {
        grabCursor: true,
        centeredSlides: false,
        //centeredSlidesBounds: true,
        effect: "creative",
        slidesPerView: 1.16,
        initialSlide: 1,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        navigation: {
          nextEl: ".my-carousel__control--next",
          prevEl: ".my-carousel__control--prev" },
          creativeEffect: {
          perspective: true,
          limitProgress: 3,
          prev: {
            translate: ["-100%", "4%", 0],
            rotate: [0, 0, -6],
            origin: "bottom"
          },
          next: {
            translate: ["100%", "4%", 0],
            rotate: [0, 0, 6],
            origin: "bottom"
          }
        },

        breakpoints: {
          768: {
              slidesPerView: 1.5,
              centeredSlides: true,
            
          },
          1200: {
              slidesPerView: 3,
              centeredSlides: true,
              initialSlide: 1,
          }
        }
  
});

// const text = document.querySelector(".collection__circle_text p");

// text.innerHTML = text.innerText
//   .split("")
//   .map(
//     (char, i) => `<span style="transform:rotate(${i * 5.8}deg)">${char}</span>`
//   )
//   .join("");


// const text = document.querySelector(".collection__circle_text");
// text.innerHTML = text.innerText
// 	.split("")
// 	.map(
// 		(char, i) => `<span style="transform:rotate(${i * 10.3}deg)">${char}</span>`
// 	)
// 	.join("");

// =========================================== Category navigation ================================

document.addEventListener('DOMContentLoaded', function() {
  function createMoreMenu() {
      var navItems = document.querySelectorAll('.collection-nav > li');
      if (navItems.length > 1) {
          var moreItem = document.createElement('li');
          moreItem.className = 'more collection-dropdown';
          moreItem.innerHTML = 'More+ <ul class="collection-dropdown-list"></ul>';
          var sublist = moreItem.querySelector('ul');
          for (var i = 1; i < navItems.length; i++) {
              sublist.appendChild(navItems[i]);
          } 
          document.querySelector('.collection-nav').appendChild(moreItem);
          moreItem.addEventListener('click', function(event) {
              sublist.style.display = sublist.style.display === 'block' ? 'none' : 'block';
              event.stopPropagation();
          });
          document.addEventListener('click', function() {
              sublist.style.display = 'none';
          });
      }
  }

  if (window.innerWidth < 767) {
      createMoreMenu();
  }
  window.addEventListener('resize', function() {
      if (window.innerWidth < 767) {
          if (!document.querySelector('.more')) {
              createMoreMenu();
          }
      } else {
          var moreItem = document.querySelector('.more');
          if (moreItem) {
              var sublistItems = moreItem.querySelectorAll('ul li');
              sublistItems.forEach(function(item) {
                  document.querySelector('.collection-nav').insertBefore(item, moreItem);
              });
              moreItem.remove();
          }
      }
  });
});
  

//=================== Tabs =================================

// document.addEventListener('DOMContentLoaded', () => {
//   const tabLinks = document.querySelectorAll('.prdTab-link');
//   const tabContents = document.querySelectorAll('.products__item--content');
//   tabLinks.forEach(link => {
//       link.addEventListener('click', (event) => {
//           const targetTab = event.currentTarget.getAttribute('data-tab');
//           tabLinks.forEach(link => link.classList.remove('active'));
//           tabContents.forEach(content => content.classList.remove('active'));
//           event.currentTarget.classList.add('active');
//           document.getElementById(targetTab).classList.add('active');
//       });
//   });
//   tabLinks[0].classList.add('active');
//   tabContents[0].classList.add('active');
// });

document.addEventListener('DOMContentLoaded', () => {

  const tabContainers = document.querySelectorAll('.cat__productsGroup');

    tabContainers.forEach(container => {
      const tabLinks = container.querySelectorAll('.tab-link');
      const tabContents = container.querySelectorAll('.tab-content');
      function activateTab(targetTab) {
        // Remove active class from all tab links
        tabLinks.forEach(link => link.classList.remove('tab-active'));

        // Remove active class from all tab contents
        tabContents.forEach(content => content.classList.remove('tab-active'));

        
       document.querySelector(`.tab-link[data-tab="${targetTab}"]`).classList.add('tab-active');
        document.getElementById(targetTab).classList.add('tab-active');
        document.getElementById(`${targetTab}-duplicate`).classList.add('tab-active');
    }

    tabLinks.forEach(link => {
      link.addEventListener('click', (event) => {
          const targetTab = event.currentTarget.getAttribute('data-tab');
          activateTab(targetTab);
      });
  });
    });


    //const tabLinks = document.querySelectorAll('.tab-link');
    //const tabContents = document.querySelectorAll('.tab-content');
    

  // Set the first tab as active by default
  //activateTab('tab1');
});





// Modal Cart
const body = document.querySelector("body");
const modalCart = document.querySelector(".modal-cart-block");
const modalCartMain = document.querySelector(
  ".modal-cart-block .modal-cart-main"
);
// const closeCartIcon = document.querySelector(".modal-cart-main .close-btn");
const addCartBtns = document.querySelectorAll(".add-cart-btn");

const openModalCart = () => {
  body.classList.add("side-cart-open");
  modalCartMain.classList.add("open");
};

const closeModalCart = () => {
  modalCartMain.classList.remove("open");
  body.classList.remove("side-cart-open");
};
modalCart.addEventListener("click", closeModalCart);
modalCartMain.addEventListener("click", (e) => {
  e.stopPropagation();
});


// document.addEventListener('DOMContentLoaded', () => {
//   const steps = document.querySelectorAll('.modal-step');
//   const stepNames = document.querySelectorAll('.modal-step-name');
//   const stepCounts = document.querySelectorAll('.step-count');
//   const prevBtn = document.getElementById('prevBtn');
//   const nextBtn = document.getElementById('nextBtn');
//   const submitBtn = document.getElementById('checkout');
//   let currentStep = 0;

//   const showStep = () => {
//       steps.forEach((step, index) => step.classList.toggle('active', index === currentStep));
//       stepNames.forEach((stepName, index) => stepName.classList.toggle('active', index === currentStep));
//       stepCounts.forEach(stepCount => {
//           stepCount.innerHTML = `<span>${String(currentStep + 1).padStart(2, '0')}</span>/${String(steps.length).padStart(2, '0')}`;
//       });
//       nextBtn.style.display = currentStep === steps.length - 2 ? 'none' : 'inline';
//       submitBtn.style.display = currentStep === steps.length - 2 ? 'inline' : 'none';
//   };

//   const changeStep = (stepChange) => {
//       currentStep = Math.max(0, Math.min(steps.length - 1, currentStep + stepChange));
//       showStep();
//   };

//   prevBtn.addEventListener('click', () => changeStep(-1));
//   nextBtn.addEventListener('click', () => changeStep(1));

//   showStep();
// });



document.addEventListener('DOMContentLoaded', () => {
  const steps = document.querySelectorAll('.modal-step');
  const stepNames = document.querySelectorAll('.modal-step-name');
  const stepCounts = document.querySelectorAll('.step-count');
  const prevBtn = document.getElementById('prevBtn');
  const nextBtn = document.getElementById('nextBtn');
  const submitBtn = document.getElementById('checkout');
  let currentStep = 0;

  const showStep = () => {
      steps.forEach((step, index) => {
          step.classList.toggle('active', index === currentStep);
          step.classList.toggle('complete', index < currentStep);
      });
      stepNames.forEach((stepName, index) => {
          stepName.classList.toggle('active', index === currentStep);
          stepName.classList.toggle('complete', index < currentStep);
      });
      stepCounts.forEach(stepCount => {
          stepCount.innerHTML = `<span>${String(currentStep + 1).padStart(2, '0')}</span>/${String(steps.length).padStart(2, '0')}`;
      });
      //prevBtn.style.display = currentStep === 0 ? 'none' : 'inline';
      nextBtn.style.display = currentStep === steps.length - 2 ? 'none' : 'inline';
      submitBtn.style.display = currentStep === steps.length - 2 ? 'inline' : 'none';
  };

  const changeStep = (stepChange) => {

      currentStep = Math.max(0, Math.min(steps.length - 1, currentStep + stepChange));
      showStep();

  };

  const nextStep = document.querySelector('.next-step');
  
  prevBtn.addEventListener('click', () => {
    console.log(currentStep)
    if(currentStep == 0 ){
      const body1 = document.querySelector("body");
      const modalCartMain1 = document.querySelector(
        ".modal-cart-block .modal-cart-main"
      );
      if (window.innerWidth < 991) {
          $('.modal-cart-main .modal-cart-left').hide(); 
      }else{
          modalCartMain1.classList.remove("open");
          body1.classList.remove("side-cart-open");
      }
    }else{
      changeStep(-1);
    }

  });
  nextBtn.addEventListener('click', () => changeStep(1));
nextStep.addEventListener('click', () => changeStep(1));
  showStep();
});






document.querySelectorAll('.rtt_range-wrapper').forEach(function(container) {
  var slider = container.querySelector('.rtt_range-slider');
  var customSlider = container.querySelector('.rtt_inr-slider');
  var fill = container.querySelector('.rtt__slideBar .rtt__slideFill');
  var thumb = container.querySelector('.rtt__slideThumb');
  var fillValue = container.querySelector('.rtt__slideNumber');
  function setBar(value) {
      var roundedValue = Math.round(value);
      fillValue.textContent = roundedValue;
      var percentage = (roundedValue - slider.min) / (slider.max - slider.min) * 100;
      thumb.style.left = percentage + "%";
      customSlider.style.setProperty('--width', percentage + "%"); 
  }

  function updateSlider(event) {
 
      var rect = customSlider.getBoundingClientRect();
      var offsetX = event.clientX - rect.left;
      var percentage = (offsetX / rect.width) * 100;
      var newValue = (percentage / 100) * (slider.max - slider.min) + parseFloat(slider.min);
      newValue = Math.min(Math.max(newValue, slider.min), slider.max); // Ensure value stays within range
      console.log(Math.round(newValue)); 
      slider.value = Math.round(newValue);
      setBar(slider.value);
  }
  setBar(slider.value);
  customSlider.addEventListener("click", updateSlider);
  thumb.addEventListener("mousedown", function() {
      document.addEventListener("mousemove", updateSlider);
      document.addEventListener("mouseup", function() {
          document.removeEventListener("mousemove", updateSlider);
      }, { once: true });
  });
});


// window.addEventListener("load", (event) => {
//   console.log("page is fully loaded");

//   var closeDrawer = document.querySelector('.menu-drawer-close');
//   if (closeDrawer) {
//     console.log("Found the closeDrawer element:", closeDrawer);
//     closeDrawer.addEventListener("click", function(){
//       console.log('aaaaa');
//     });
//   } else {
//     console.log("closeDrawer element not found");
//   }
// });

(function () {
  let intervalId = null;

  function updateHeight() {
    const el = document.querySelector('.sideCartBottom');
    if (!el) return;

    // Element exists but still hidden
    if (el.offsetHeight === 0) return;

    document.documentElement.style.setProperty(
      '--side-cart-bottom-height',
      el.offsetHeight + 'px'
    );
  }

  function startChecking() {
    if (intervalId) return;

    intervalId = setInterval(() => {
      updateHeight();
    }, 100); // check every 100ms
  }

  function stopChecking() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }

  // Start checking on load
  window.addEventListener('load', startChecking);

  // Also update on resize
  window.addEventListener('resize', updateHeight);
})();
$(document).ready(function(){
  //$('.menu-drawer-close').click(function(){
    $('.menu-drawer-close').on( "click", function(){
    console.log('aaaa');
     $('.menu-drawer-container').removeClass('menu-opening');
      $('.menu-drawer-container').removeAttr("open");
      $('.menu-drawer-container .header__icon').attr("aria-expanded", "false");
      $('body').removeClass('overflow-hidden-desktop');
  });
})
